import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewRelatedVODSportRoomContents from './viewRelatedVODSportRoomContents';

export default {
  title: 'Manager',
  attributeName: 'VODGraphicManagerFormGroup',
  fields: [
    {
      attributeName: 'name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Content name',
      label: 'Manager Name',
      required: true,
      helpText: 'Name of the content',
      default:'Master',
      errorText: '',
    },
    // {
    //   attributeName: 'attachedAPPContent',
    //   label: 'Attach Apps Content',
    //   type: FormInputTypes.RELATIONSHIPFILTER,
    //   helpText: 'Select App contents to be controlled by this manager',
    //   canEdit: true,
    //   canCreate: true,
    //   configFile: viewRelatedVODAppContents,
    // },
    {
      attributeName: 'attachedSportRoomsContent',
      label: 'Attach Rooms Content',
      type: FormInputTypes.RELATIONSHIPFILTER,
      helpText: 'Select  Room contents to be controlled by this manager',
      canEdit: true,
      canCreate: true,
      configFile: viewRelatedVODSportRoomContents,
    },
  ],
};
